const Styles = {
  containerStyle: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  informationContainerStyle: {
    display: 'flex',
    width: '35%',
    backgroundColor: '#3B424D',
    paddingTop: 128,
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 15,
    paddingRight: 15
  },
  newErrorReportContainerStyle: {
    display: 'flex',
    flex: 1,
    paddingTop: 128,
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 15,
    paddingRight: 15
  },
  headerStyle: {
    color: '#e57373'
  },
  textStyle: {
    color: '#f4f4f8'
  },
  radioButtonsContainerStyle: {
    maxWidth: 350,
    width: '80%',
    display: 'flex',
    marginTop: 25,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column'
  },
  criticalStatusContainerStyle: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex'
  },
  locationContainerStyle: {
    width: '100%',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column'
  },
  placeholderStyle: {
    fontSize: 14
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/errorReports/NewErrorReport/styles.js